export default __webpack_public_path__ + "static/media/mkv.f4a0e689.svg";